/**
 * @generated SignedSource<<73455e850cf10302f4c9209006c28dcd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RenderContentBlockQuery$variables = {
  identifier: string;
  rotate: boolean;
};
export type RenderContentBlockQuery$data = {
  readonly block: {
    readonly " $fragmentSpreads": FragmentRefs<"RenderContentBlock_block">;
  } | null;
};
export type RenderContentBlockQuery = {
  response: RenderContentBlockQuery$data;
  variables: RenderContentBlockQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "identifier"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "rotate"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "identifier",
    "variableName": "identifier"
  },
  {
    "kind": "Variable",
    "name": "rotate",
    "variableName": "rotate"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RenderContentBlockQuery",
    "selections": [
      {
        "alias": "block",
        "args": (v1/*: any*/),
        "concreteType": "ContentBlock",
        "kind": "LinkedField",
        "name": "contentBlock",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RenderContentBlock_block"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RenderContentBlockQuery",
    "selections": [
      {
        "alias": "block",
        "args": (v1/*: any*/),
        "concreteType": "ContentBlock",
        "kind": "LinkedField",
        "name": "contentBlock",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e88f6488810aeb3f16653c4026ba9e63",
    "id": null,
    "metadata": {},
    "name": "RenderContentBlockQuery",
    "operationKind": "query",
    "text": "query RenderContentBlockQuery(\n  $identifier: String!\n  $rotate: Boolean!\n) {\n  block: contentBlock(identifier: $identifier, rotate: $rotate) {\n    ...RenderContentBlock_block\n    id\n  }\n}\n\nfragment RenderContentBlock_block on ContentBlock {\n  id\n  content\n}\n"
  }
};
})();

(node as any).hash = "47c1a4b50368f73ee97eb8c365778252";

export default node;
